var render = function render(){var _vm=this,_c=_vm._self._c;return _c(!_vm.disabled && _vm.to ? 'AeLink' : 'button',{tag:"Component",staticClass:"button-plain",attrs:{"to":_vm.to,"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }